<!--
    @description : 药品详情页面
    @api-property :
    @api-event :
    @api-method :

    @author :
    @dateTime :
    @lastEditDateTime :
    @lastEditors :
-->
<template>
  <div class="medicine-detail-container">
    <!-- 返回按钮区域 -->
    <div class="header-section">
      <el-page-header
        @back="goBack"
        :content="medicineData && medicineData.name ? medicineData.name : '药品详情'"
        class="page-header"
      ></el-page-header>
    </div>

    <!-- 药品信息主体内容 -->
    <div class="medicine-content" v-if="!loading && !errorMsg">
      <!-- 左侧药品图片区域 -->
      <div class="medicine-image-section">
        <el-image
          v-if="medicineData && medicineData.imageUrl"
        :src="medicineData.imageUrl"
          class="medicine-image"
          fit="contain"
          lazy
          :preview-src-list="[medicineData && medicineData.imageUrl ? medicineData.imageUrl : '']"
        ></el-image>
        <div v-else class="image-placeholder">暂无图片</div>
      </div>

      <!-- 右侧药品信息区域 -->
      <div class="medicine-details-section">
        <h2 class="medicine-name">{{ medicineData && medicineData.name ? medicineData.name : '未知药品' }}</h2>
        
        <div class="medicine-tags">
          <el-tag
            v-for="(tag, index) in medicineData && medicineData.tags ? medicineData.tags : []"
            :key="index"
            size="small"
            type="success"
            plain
          >
            {{ tag }}
          </el-tag>
        </div>

        <div class="medicine-info-list">
          <div class="info-item">
            <span class="info-label">通用名称：</span>
            <span class="info-value">{{ medicineData && medicineData.basicInfo && medicineData.basicInfo.genericName ? medicineData.basicInfo.genericName : '-' }}</span>
          </div>
          <div class="info-item">
            <span class="info-label">功能主治：</span>
            <span class="info-value">{{ medicineData && medicineData.basicInfo && medicineData.basicInfo.indications ? medicineData.basicInfo.indications : '-' }}</span>
          </div>
          <div class="info-item">
            <span class="info-label">规格：</span>
            <span class="info-value">{{ medicineData && medicineData.basicInfo && medicineData.basicInfo.specification ? medicineData.basicInfo.specification : '-' }}</span>
          </div>
          <div class="info-item">
            <span class="info-label">用法用量：</span>
            <span class="info-value">{{ medicineData && medicineData.basicInfo && medicineData.basicInfo.usageDosage ? medicineData.basicInfo.usageDosage : '-' }}</span>
          </div>
          <!-- <div class="info-item">
            <span class="info-label">生产企业：</span>
            <span class="info-value">{{ medicineData && medicineData.basicInfo && medicineData.basicInfo.manufacturer ? medicineData.basicInfo.manufacturer : '-' }}</span>
          </div>
          <div class="info-item">
            <span class="info-label">批准文号：</span>
            <span class="info-value">{{ medicineData && medicineData.basicInfo && medicineData.basicInfo.approvalNumber ? medicineData.basicInfo.approvalNumber : '-' }}</span>
          </div> -->
          <div class="info-item">
            <span class="info-label">有效期：</span>
            <span class="info-value">{{ medicineData && medicineData.basicInfo && medicineData.basicInfo.validityPeriod ? medicineData.basicInfo.validityPeriod : '-' }}</span>
          </div>
          <div class="info-item">
            <span class="info-label">不良反应：</span>
            <span class="info-value">{{ medicineData && medicineData.basicInfo && medicineData.basicInfo.adverseReactions ? medicineData.basicInfo.adverseReactions : '-' }}</span>
          </div>
          <div class="info-item">
            <span class="info-label">禁忌：</span>
            <span class="info-value">{{ medicineData && medicineData.basicInfo && medicineData.basicInfo.contraindications ? medicineData.basicInfo.contraindications : '-' }}</span>
          </div>
          <div class="info-item">
            <span class="info-label">注意事项：</span>
            <span class="info-value">{{ medicineData && medicineData.basicInfo && medicineData.basicInfo.precautions ? medicineData.basicInfo.precautions : '-' }}</span>
          </div>
        </div>
      </div>
    </div>

    <!-- 加载状态 -->
    <div v-else-if="loading" class="loading-container">
      <el-skeleton animated :rows="8" class="loading-skeleton"></el-skeleton>
      <p class="loading-text">正在加载药品信息...</p>
    </div>

    <!-- 错误提示 -->
    <div v-else-if="errorMsg" class="error-container">
      <el-empty description="暂无药品信息" class="error-empty">
        <el-button type="primary" @click="reloadMedicineData">重新加载</el-button>
      </el-empty>
      <p class="error-text">{{ errorMsg }}</p>
    </div>

    <!-- 药品详细说明区域 -->
    <div class="medicine-description-section" v-if="medicineData && medicineData.description && !loading && !errorMsg">
      <h3 class="section-title">详细说明</h3>
      <div class="description-content" v-html="medicineData.description"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MedicineDetail',
  props: {},
  data() {
    return {
      // 药品数据数组
      medicineList: [
        {
          id: 'M003',
          name: '复方氨酚烷胺胶囊(快克)',
          imageUrl: require('@/assets/medicine/M003.jpg'),
          tags: ['感冒用药', '非处方药', '解热镇痛'],
          basicInfo: {
            genericName: '复方氨酚烷胺胶囊',
            indications: '适用于缓解普通感冒及流行性感冒引起的发热，头痛，四肢酸痛，打喷嚏。流鼻涕、鼻塞、咽痛等症状，也可用于流行性感冒的预防和治疗。',
            specification: '8粒*2板',
            usageDosage: '口服。成人一次1粒　一日2次。',
            manufacturer: '',
            approvalNumber: '',
            validityPeriod: '36月',
            adverseReactions: '有时有轻度头晕、乏力、恶心、上腹不适、口干、食欲缺乏和皮疹等，可自行恢复。',
            contraindications: '严重肝肾功能不全者禁用。',
            precautions: '1、用药3-7天，症状未缓解，请咨询医师或药师。 2、服用本品期间不得饮酒或含有酒精的饮料。 3、不能同时服用与本品成份相似的其他抗感冒药。 4、前列腺肥大、青光眼等患者以及老年人应在医师指导下使用。 5、肝功能不全、肾功能不全、脑血管病史、精神病史或癫痫病史患者慎用。 6、孕妇及哺乳期妇女慎用。 7、服药期间不得驾驶机、车、船、从事高空作业、机械作业及操作精密仪器。 8、如服用过量或出现严重不良反应，应立即就医。 9、对本品过敏者禁用，过敏体质者慎用。 10、本品性状发生改变时禁止使用。 11、请将本品放在儿童不能接触的地方。 12、如正在使用其他药品，使用本品前请咨询医师或药师。',
            packingUnit: '盒',
            mainIngredients: '本品为复方制剂。每粒含对乙酰氨基酚250mg，盐酸金刚烷胺100mg、马来酸氯苯那敏2mg、人工牛黄10mg、咖啡因15mg。辅料为糊精。',
            appearance: '本品为胶囊剂，内容物为淡黄色的小丸。',
            applicablePopulation: '成人',
            pregnancyAndLactationUse: '孕妇及哺乳期妇女慎用。',
            childUse: '尚不明确。',
            elderlyUse: '尚不明确。',
            storage: '密封，置阴凉（不超过20℃）干燥处。'
          },
          description: `
            <h4>药品简介</h4>
            <p>复方氨酚烷胺胶囊是一种常用的复方抗感冒药，具有解热镇痛、抗病毒等作用。</p>
            <h4>药理作用</h4>
            <p>对乙酰氨基酚能抑制前列腺素合成，有解热镇痛作用；金刚烷胺可抗"亚-甲型"流感病毒，抑制其繁殖；咖啡因为中枢兴奋药，能增强对乙酰氨基酚的解热镇痛效果，并减轻其他药物所致的嗜睡、头晕等中枢抑制作用；马来酸氯苯那敏为抗组胺药，能减轻流涕、鼻塞、打喷嚏症状；人工牛黄具有解热、镇惊作用。</p>
            <h4>临床应用</h4>
            <p>主要用于缓解普通感冒及流行性感冒引起的各种症状，也可用于流行性感冒的预防和治疗。</p>
            <h4>注意事项</h4>
            <p>用药期间应避免饮酒，注意休息，多喝水。如症状持续不缓解或加重，应及时就医。</p>
          `
        },
        {
          id: 'M022',
          name: '氯雷他定片(开瑞坦)',
          imageUrl: require('@/assets/medicine/M022.jpg'),
          tags: ['抗过敏药', '非处方药', '抗组胺药'],
          basicInfo: {
            genericName: '氯雷他定片',
            indications: '用于缓解过敏性鼻炎有关的症状，如喷嚏、流涕、鼻痒、鼻塞以及眼部痒及烧灼感。口服药物后，鼻和眼部症状及体征得以迅速缓解。亦适用于缓解慢性荨麻疹、瘙痒性皮肤病及其他过敏性皮肤病的症状及体征。',
            specification: '10mg*12片',
            usageDosage: '成人及12岁以上儿童：一日1次，一次1片（10mg）。 2_12岁儿童：体重>30公斤：一日1次，一次1片（10mg）。 体重＜30 公斤：一日1次，一次半片（5mg）。',
            manufacturer: '',
            approvalNumber: '',
            validityPeriod: '48月',
            adverseReactions: '在每天10mg的推荐剂量下，本品未见明显的镇静作用。常见不良反应有乏力、头痛、嗜睡、口干、胃肠道不适包括恶心、胃炎以及皮疹等。罕见不良反应有脱发、过敏反应、肝功能异常、心动过速及心悸等。',
            contraindications: '对本品过敏者或特异体质的患者禁用。',
            precautions: '1.严重肝功能不全的患者请在医生指导下使用。 2.妊娠期及哺乳期妇女慎用。 3.在作皮试前的约48小时左右应中止使用本品，因抗组胺药能阻止或降低皮试的阳性反应发生。 4.对本品过敏者禁用，过敏体质者慎用。 5.本品性状发生改变时禁止使用。 6.请将本品放在儿童不能接触的地方。 7.儿童必须在成人监护下使用。 8.如正在使用其他药品，使用本品前请咨询医师或药师。',
            packingUnit: '盒',
            mainIngredients: '本品每片含氯雷他定10毫克。辅料为：一水乳糖、玉米淀粉、硬脂酸镁。',
            appearance: '本品为白色或类白色片。',
            applicablePopulation: '不限',
            pregnancyAndLactationUse: '尚不明确。',
            childUse: '尚不明确。',
            elderlyUse: '尚不明确。',
            storage: '密封。'
          },
          description: `
            <h4>药品简介</h4>
            <p>氯雷他定片(开瑞坦)是一种常用的第二代抗组胺药，具有长效、强效、选择性的外周H1受体拮抗作用。</p>
            <h4>药理作用</h4>
            <p>氯雷他定是一种长效三环类抗组胺药，可通过选择性地拮抗外周组胺H1受体，缓解过敏反应引起的各种症状。本品无明显的抗胆碱和中枢抑制作用。</p>
            <h4>临床应用</h4>
            <p>主要用于缓解过敏性鼻炎的症状，如喷嚏、流涕、鼻痒、鼻塞以及眼部痒及烧灼感；也适用于缓解慢性荨麻疹、瘙痒性皮肤病及其他过敏性皮肤病的症状及体征。</p>
            <h4>注意事项</h4>
            <p>严重肝功能不全者应在医生指导下使用；妊娠期及哺乳期妇女慎用；用药期间如出现严重不良反应，应立即停药并就医。</p>
          `
        },
        {
          id: 'MED003',
          name: '布洛芬混悬液(美林) 100ml',
          imageUrl: require('@/assets/medicine/MED003.png'),
          tags: ['儿童用药', '非处方药', '解热镇痛'],
          basicInfo: {
            genericName: '布洛芬混悬液',
            indications: '用于儿童普通感冒或流感引起的发热。也用于缓解儿童轻至中度疼痛，如头痛、关节痛、偏头痛、牙痛、肌肉痛、神经痛。',
            specification: '100ml',
            usageDosage: '口服，成人一次15-20毫升，一日3-4次。 12岁以下小儿：1～3岁，体重10～15公斤，一次4毫升；4～6岁，体重16～21公斤，一次5毫升；7～9岁，体重22～27公斤，一次8毫升；10～12岁，体重28～32公斤，一次10毫升。若持续疼痛或发热， 可间隔4—6小时重复用药1次，24小时不超过4次。',
            manufacturer: '',
            approvalNumber: '',
            validityPeriod: '36月',
            adverseReactions: '1.少数病人可出现恶心、呕吐、胃烧灼感或轻度消化不良、胃肠道溃疡及出血、转氨酶升高、头痛、头晕、耳鸣、视力模糊、精神紧张、嗜睡、下肢水肿或体重骤增。 2.罕见皮疹、过敏性肾炎、膀胱炎、肾病综合症、肾乳头坏死或肾功能衰竭、支气管痉挛。',
            contraindications: '1.对其他非甾体抗炎药过敏者禁用。 2.对阿司匹林过敏的哮喘患者禁用。',
            precautions: '1.本品为对症治疗药，不宜长期或大量使用，用于止痛不得超过5天；用于解热不得超过3天，症状不缓解，请咨询医师或药师。 2.有下列情况患者慎用：支气管哮喘、肝肾功能不全、凝血机制或血小板功能障碍（如血友病）。 3.下列情况患者应在医师指导下使用：有消化性溃疡史、胃肠道出血、心功能不全、高血压。 4.1岁以下儿童应在医师指导下使用。 5.不能同时服用其他含有解热镇痛药的药品（如某些复方抗感冒药）。 6.如服用过量或出现严重不良反应，应立即就医。 7.对本品过敏者禁用，过敏体质者慎用。 8.本品性状发生改变时禁止使用。 9.请将本品放在儿童不能接触的地方。 10.儿童必须在成人监护下使用。 11.如正在使用其他药品，使用本品前请咨询医师或药师。 12.本品配有儿童安全盖，其打开方式见说明书所附图示。 13.如出现胃肠道出血或溃疡、胸痛、气短、无力、言语含糊等情况，应停药并咨询医师。 14.第一次使用本品如出现皮疹或过敏症状，应停药并咨询医师。',
            packingUnit: '瓶',
            mainIngredients: '本品每毫升含主要成分布洛芬20毫克。辅料为预胶化淀粉、黄原胶、甘油、蔗糖、无水枸橼酸、苯甲酸钠、吐温80、食用色素、食用香精、纯水。',
            appearance: '本品为橙色混悬液，味甜，有调味剂的芳香。',
            applicablePopulation: '儿童',
            pregnancyAndLactationUse: '尚不明确。',
            childUse: '1岁以下儿童应在医师指导下使用。',
            elderlyUse: '尚不明确。',
            storage: '密封。'
          },
          description: `
            <h4>药品简介</h4>
            <p>布洛芬混悬液(美林)是一种常用的儿童用解热镇痛药物，为橙色混悬液，味甜，适合儿童服用。</p>
            <h4>药理作用</h4>
            <p>布洛芬通过抑制前列腺素的合成，发挥解热、镇痛、抗炎作用。混悬液剂型便于儿童服用和剂量控制。</p>
            <h4>临床应用</h4>
            <p>主要用于儿童普通感冒或流感引起的发热，也可用于缓解儿童轻至中度疼痛，如头痛、关节痛、牙痛、肌肉痛等。</p>
            <h4>注意事项</h4>
            <p>不宜长期或大量使用；用于解热不得超过3天，用于止痛不得超过5天；儿童必须在成人监护下使用；如出现不良反应，应立即停药并咨询医师。</p>
          `
        },
        {
          id: 'M052',
          name: '小儿氨酚黄那敏颗粒(999) 6g*10袋',
          imageUrl: require('@/assets/medicine/M052.png'),
          tags: ['儿童用药', '非处方药', '感冒用药'],
          basicInfo: {
            genericName: '小儿氨酚黄那敏颗粒',
            indications: '适用于缓解儿童普通感冒及流行性感冒引起的发热、头痛、四肢酸痛、打喷嚏、流鼻涕、鼻塞、咽痛等症状。',
            specification: '6g*10袋',
            usageDosage: '温水冲服。儿童用量见下表。 年龄（岁） 体重（公斤） 一次用量（袋） 一日次数 1～3 10～15 0.5～1 一日3次 4～6 16～21 1～1.5 一日3次 7～9 22～27 1.5～2 一日3次 10～12 28～32 2～2.5 一日3次',
            manufacturer: '',
            approvalNumber: '',
            validityPeriod: '24月',
            adverseReactions: '有时有轻度头晕、乏力、恶心、上腹不适、口干、食欲缺乏和皮疹等，可自行恢复。',
            contraindications: '严重肝肾功能不全者禁用。',
            precautions: '1.用药3-7天，症状未缓解，请咨询医师或药师。 2.服用本品期间不得饮酒或含有酒精的饮料。 3.1岁以下儿童应在医师指导下使用。 4.不能同时服用与本品成份相似的其他抗感冒药。 5.肝、肾功能不全者慎用。 6.如服用过量或出现严重不良反应，应立即就医。 7.对本品过敏者禁用，过敏体质者慎用。 8.本品性状发生改变时禁止使用。 9.请将本品放在儿童不能接触的地方。 10.儿童必须在成人监护下使用。 11.如正在使用其他药品，使用本品前请咨询医师或药师。',
            packingUnit: '盒',
            mainIngredients: '本品为复方制剂，每袋含对乙酰氨基酚125毫克，马来酸氯苯那敏0.5毫克，人工牛黄5毫克。辅料为：蔗糖、香精。',
            appearance: '本品为白色、类白色、淡黄至黄色或淡橙黄颗粒。',
            applicablePopulation: '儿童',
            pregnancyAndLactationUse: '尚不明确。',
            childUse: '1岁以下儿童应在医师指导下使用。',
            elderlyUse: '尚不明确。',
            storage: '密封，在阴凉干燥处'
          },
          description: `
            <h4>药品简介</h4>
            <p>小儿氨酚黄那敏颗粒(999)是一种适用于儿童的复方感冒药，用于缓解儿童感冒引起的各种症状。</p>
            <h4>药理作用</h4>
            <p>对乙酰氨基酚有解热镇痛作用；马来酸氯苯那敏为抗组胺药，能减轻流涕、鼻塞、打喷嚏等症状；人工牛黄具有解热、镇惊作用。</p>
            <h4>临床应用</h4>
            <p>主要用于缓解儿童普通感冒及流行性感冒引起的发热、头痛、四肢酸痛、打喷嚏、流鼻涕、鼻塞、咽痛等症状。</p>
            <h4>注意事项</h4>
            <p>1岁以下儿童应在医师指导下使用；肝肾功能不全者慎用；用药3-7天症状未缓解请咨询医师或药师；儿童必须在成人监护下使用。</p>
          `
        },
        {
          id: 'MED005',
          name: '铝碳酸镁咀嚼片(达喜)',
          imageUrl: require('@/assets/medicine/MED005.png'),
          tags: ['消化系统药', '非处方药', '抗酸药'],
          basicInfo: {
            genericName: '铝碳酸镁咀嚼片',
            indications: '慢性胃炎与胃酸有关的胃部不适应症，如胃疼，胃灼热感（烧心)，酸性嗳气，饱胀。',
            specification: '0.5g*20片',
            usageDosage: '口服(咀嚼后服用)。一次1-2片，一日3次。餐后1-2小时，睡前或胃部不适时服用。',
            manufacturer: '',
            approvalNumber: '',
            validityPeriod: '60月',
            adverseReactions: '1.偶见便秘，稀便，口干和食欲缺乏。 2.大剂量服用可导致软糊状便，大便次数增多/腹泻和呕吐。 3.过敏反应。',
            contraindications: '肾功能损伤病人(肌酐清除率<30毫升/分钟)不能长期、大剂量服用。',
            precautions: '1.肾功能不全者（肌酐清除率为30-80毫升/分钟），高美血症，高钙血症者及严重肾功能不全者慎用。 2.孕妇如使用本品后发生腹泻，易增加流产，早晨风险，妊娠其头3个月慎用，妊娠三个月以上应咨询医生。 3.目前尚无铝碳酸镁通过乳汁分泌的资料。哺乳期妇女应咨询医生。 4.尚无儿童用药和老年用药的安全性和有效性资料，应在医师的指导下使用 5.急腹症患者应在医师指导下使用。 6.低碳饮食的患者应在医师指导下使用。 7.本品连续使用不得超过7天，症状未缓解，请咨询医师或药师。持续复发的胃病有可能是严重疾病（例如胃或十二指肠溃疡） 8.如服用过量或出现严重的不良反应，过敏体质者慎用。 9.对本品过敏者禁用，过敏体质者慎用。 10.本品性状发生改变时禁止使用。 11.请将本品放在儿童不能接触的地方。 12.儿童必须在成人监护下使用。 13.如正在使用其他药品，使用本品前请咨询医师或药师。',
            packingUnit: '盒',
            mainIngredients: '本品每片含0.5克铝碳酸镁。辅料为：玉米淀粉，甘露醇，糖精钠，硬脂酸镁，薄荷香精，香蕉香精。',
            appearance: '本品为白色片。',
            applicablePopulation: '不限',
            pregnancyAndLactationUse: '妊娠头3个月慎用，妊娠三个月以上应咨询医生。哺乳期妇女应咨询医生。',
            childUse: '应在医师指导下使用。',
            elderlyUse: '应在医师指导下使用。',
            storage: '密封。'
          },
          description: `
            <h4>药品简介</h4>
            <p>铝碳酸镁咀嚼片(达喜)是一种抗酸与胃黏膜保护类非处方药药品，用于治疗与胃酸相关的胃部不适症状。</p>
            <h4>药理作用</h4>
            <p>铝碳酸镁是一种抗酸药，能中和胃酸，缓解胃酸过多引起的胃痛、胃灼热感（烧心）、酸性嗳气等症状。</p>
            <h4>临床应用</h4>
            <p>主要用于慢性胃炎与胃酸有关的胃部不适应症，如胃疼，胃灼热感（烧心)，酸性嗳气，饱胀等症状的缓解。</p>
            <h4>注意事项</h4>
            <p>肾功能不全者慎用；孕妇及哺乳期妇女应在医生指导下使用；本品连续使用不得超过7天，症状未缓解请咨询医师或药师。</p>
          `
        }
      ],
      // 当前显示的药品数据
      medicineData: {},
      loading: false,
      errorMsg: ''
    }
  },
  computed: {
    // 判断是否有药品数据
    hasMedicineData() {
      return this.medicineData && Object.keys(this.medicineData).length > 0
    },
    // 获取药品ID
    medicineId() {
      return this.$route.query.id || ''
    }
  },
  created() {
    this.fetchMedicineDetails()
  },
  methods: {
    // 获取药品详情数据
    async fetchMedicineDetails() {
      if (!this.medicineId) {
        this.errorMsg = '未提供药品ID'
        return
      }
      
      this.loading = true
      this.errorMsg = ''
      
      try {
        // 模拟API调用延迟
        await new Promise(resolve => setTimeout(resolve, 200))
        
        // 根据药品ID从数组中查找对应药品信息
        const foundMedicine = this.medicineList.find(medicine => medicine.id === this.medicineId)
        
        if (foundMedicine) {
          // 找到匹配的药品数据
          this.medicineData = foundMedicine
        } else {
          // 未找到匹配的药品数据
          this.errorMsg = '未找到该药品信息'
          this.medicineData = {}
        }
        
        // 数据校验
        this.validateMedicineData()
      } catch (error) {
        console.error('获取药品详情失败:', error)
        this.errorMsg = '获取药品信息失败，请稍后重试'
      } finally {
        this.loading = false
      }
    },
    
    // 数据校验
    validateMedicineData() {
      if (!this.medicineData.name) {
        this.medicineData.name = '未知药品'
      }
      
      // 初始化basicInfo对象，避免访问undefined属性
      if (!this.medicineData.basicInfo) {
        this.medicineData.basicInfo = {
          genericName: '',
          indications: '',
          specification: '',
          usageDosage: '',
          manufacturer: '',
          approvalNumber: '',
          validityPeriod: '',
          adverseReactions: '',
          contraindications: '',
          precautions: ''
        }
      }
    },
    
    // 重新加载数据
    reloadMedicineData() {
      this.fetchMedicineDetails()
    },
    
    // 返回到药品列表页
    goBack() {
      this.$router.push({
        name: 'medicineInfo'
      })
    }
  },
  watch: {
    // 监听路由参数变化，重新获取数据
    '$route.query.id': {
      handler(newId) {
        if (newId) {
          this.fetchMedicineDetails()
        }
      },
      immediate: false
    }
  }
}
</script>

<style scoped lang="less">
.medicine-detail-container {
  min-height: calc(100vh - 100px);
  padding: 20px;
  background-color: #f5f7fa;
  
  .header-section {
    margin-bottom: 20px;
    
    .page-header {
      background-color: #fff;
      padding: 15px 20px;
      border-radius: 8px;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
      
      .el-page-header__left {
        .el-page-header__title {
          font-size: 20px;
          color: #303133;
        }
      }
    }
  }
  
  .medicine-content {
    display: flex;
    gap: 30px;
    background-color: #fff;
    padding: 30px;
    border-radius: 12px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
    margin-bottom: 30px;
    
    .medicine-image-section {
      flex: 0 0 300px;
      display: flex;
      align-items: center;
      justify-content: center;
      
      .medicine-image {
        width: 100%;
        height: 400px;
        border-radius: 8px;
        object-fit: cover;
      }
      
      .image-placeholder {
        width: 100%;
        height: 400px;
        background-color: #f0f2f5;
        border-radius: 8px;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #909399;
        font-size: 16px;
      }
    }
    
    .medicine-details-section {
      flex: 1;
      
      .medicine-name {
        font-size: 24px;
        font-weight: bold;
        color: #303133;
        margin-bottom: 16px;
        padding-bottom: 16px;
        border-bottom: 2px solid #409eff;
      }
      
      .medicine-tags {
        margin-bottom: 20px;
        
        .el-tag {
          margin-right: 8px;
          margin-bottom: 8px;
        }
      }
      
      .medicine-info-list {
        
        .info-item {
          display: flex;
          margin-bottom: 16px;
          padding-bottom: 16px;
          border-bottom: 1px dashed #ebeef5;
          
          &:last-child {
            border-bottom: none;
          }
          
          .info-label {
            width: 100px;
            font-size: 15px;
            color: #606266;
            font-weight: 500;
          }
          
          .info-value {
            flex: 1;
            font-size: 15px;
            color: #303133;
            line-height: 1.6;
          }
        }
      }
      
      .loading-container {
        text-align: center;
        padding: 60px 0;
        
        .loading-skeleton {
          max-width: 600px;
          margin: 0 auto 20px;
        }
        
        .loading-text {
          color: #909399;
          font-size: 14px;
        }
      }
      
      .error-container {
        text-align: center;
        padding: 60px 0;
        
        .error-text {
          color: #f56c6c;
          font-size: 14px;
          margin-top: 10px;
        }
      }
    }
  }
  
  .medicine-description-section {
    background-color: #fff;
    padding: 30px;
    border-radius: 12px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
    
    .section-title {
      font-size: 18px;
      font-weight: bold;
      color: #303133;
      margin-bottom: 20px;
      padding-bottom: 10px;
      border-bottom: 2px solid #e6a23c;
    }
    
    .description-content {
      font-size: 15px;
      color: #606266;
      line-height: 1.8;
      
      h4 {
        font-size: 16px;
        color: #303133;
        margin-top: 20px;
        margin-bottom: 12px;
        font-weight: 600;
      }
      
      p {
        margin-bottom: 12px;
        text-align: justify;
      }
    }
  }
}

/* 响应式设计 - 平板设备 (768px - 1024px) */
@media screen and (max-width: 1024px) {
  .medicine-detail-container {
    .medicine-content {
      .medicine-image-section {
        flex: 0 0 250px;
        
        .medicine-image {
          height: 350px;
        }
      }
    }
  }
}

/* 响应式设计 - 大屏幕手机和小平板 (480px - 768px) */
@media screen and (max-width: 768px) {
  .medicine-detail-container {
    padding: 15px;
    
    .header-section {
      .el-page-header__left {
        .el-page-header__title {
          font-size: 18px;
        }
      }
    }
    
    .medicine-content {
      flex-direction: column;
      gap: 20px;
      padding: 15px;
      
      .medicine-image-section {
        flex: 0 0 auto;
        
        .medicine-image {
          height: 300px;
        }
      }
      
      .medicine-details-section {
        .medicine-name {
          font-size: 20px;
        }
        
        .medicine-info-list {
          .info-item {
            margin-bottom: 12px;
            padding-bottom: 12px;
            
            .info-label {
              width: 80px;
              font-size: 14px;
            }
            
            .info-value {
              font-size: 14px;
            }
          }
        }
        
        .loading-container {
          padding: 40px 0;
          
          p {
            font-size: 14px;
          }
        }
      }
    }
    
    .medicine-description-section {
      padding: 15px;
      
      .section-title {
        font-size: 16px;
      }
      
      .description-content {
        font-size: 14px;
        
        h4 {
          font-size: 15px;
        }
        
        p {
          font-size: 13px;
        }
      }
    }
  }
}

/* 响应式设计 - 手机设备 (小于480px) */
@media screen and (max-width: 480px) {
  .medicine-detail-container {
    padding: 10px;
    min-height: calc(100vh - 120px);
    
    .header-section {
      margin-bottom: 15px;
      
      .el-page-header__left {
        .el-page-header__title {
          font-size: 16px;
        }
      }
    }
    
    .medicine-content {
      gap: 15px;
      padding: 12px;
      margin-bottom: 20px;
      
      .medicine-image-section {
        .medicine-image {
          height: 250px;
        }
      }
      
      .medicine-details-section {
        .medicine-name {
          font-size: 18px;
          margin-bottom: 12px;
        }
        
        .medicine-tags {
          margin-bottom: 15px;
          
          .el-tag {
            margin-right: 6px;
            margin-bottom: 6px;
            font-size: 12px;
          }
        }
        
        .medicine-info-list {
          .info-item {
            margin-bottom: 10px;
            padding-bottom: 10px;
            
            .info-label {
              width: 70px;
              font-size: 13px;
            }
            
            .info-value {
              font-size: 13px;
            }
          }
        }
        
        .loading-container {
          padding: 30px 0;
        }
        
        .error-container {
          padding: 20px 0;
        }
      }
    }
    
    .medicine-description-section {
      padding: 12px;
      
      .section-title {
        font-size: 15px;
        margin-bottom: 15px;
        padding-bottom: 8px;
      }
      
      .description-content {
        font-size: 13px;
        line-height: 1.6;
        
        h4 {
          font-size: 14px;
          margin-top: 15px;
          margin-bottom: 8px;
        }
        
        p {
          font-size: 12px;
          margin-bottom: 8px;
        }
      }
    }
  }
}

/* 高分辨率屏幕适配 */
@media screen and (min-width: 1920px) {
  .medicine-detail-container {
    max-width: 1600px;
    margin: 0 auto;
    
    .medicine-content {
      .medicine-image-section {
        flex: 0 0 400px;
        
        .medicine-image {
          height: 500px;
        }
      }
      
      .medicine-details-section {
        .medicine-name {
          font-size: 28px;
        }
        
        .medicine-info-list {
          .info-item {
            .info-label {
              font-size: 16px;
            }
            
            .info-value {
              font-size: 16px;
            }
          }
        }
      }
    }
    
    .medicine-description-section {
      .section-title {
        font-size: 20px;
      }
      
      .description-content {
        font-size: 16px;
        
        h4 {
          font-size: 18px;
        }
      }
    }
  }
}
</style>